document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_CartItems', (context) => {
    return {
      context: context,
      itemsRoot: null,
      locked: null,
      items_section: '',
      sections: '',
      init() {
        if (context === 'drawer') {
          this.items_section = 'drawer-cart-items';
          this.sections =
            'drawer-cart-items,drawer-cart-footer,cart-item-count,cart-live-region';
        } else {
          this.items_section = 'cart-items';
          this.sections =
            'cart-items,cart-footer,cart-item-count,cart-live-region';
        }

        this.itemsRoot = this.$root;

        window.addEventListener('switch:cart:afteradditem', (e) => {
          Alpine.morph(
            this.itemsRoot,
            querySelectorInHTMLString(
              '[data-cart-items]',
              e.detail.response.sections[this.items_section]
            ).outerHTML
          );
          this.$nextTick(() => {
            document.body.dispatchEvent(new CustomEvent('switch:load:images', { bubbles: true }));
          });
        });

        window.addEventListener('switch:modalcart:cartqtychange', (e) => {
          if (!this.itemsRoot.contains(e.detail.originalTarget)) return;

          Alpine.morph(
            this.itemsRoot,
            querySelectorInHTMLString(
              '[data-cart-items]',
              e.detail.response.sections[this.items_section]
            ).outerHTML
          );

          this.$nextTick(() => {
            document.body.dispatchEvent(new CustomEvent('switch:load:images', { bubbles: true }));
            this.itemsRoot.querySelectorAll('input').forEach((inputEl) => {
              inputEl.value = inputEl.getAttribute('value');
            });
          });

          const liveRegionText = parseDOMFromString(
            e.detail.response.sections['cart-live-region']
          ).firstElementChild.textContent;

          const cartStatus = document.getElementById('cart-live-region-text');

          cartStatus.textContent = liveRegionText;

          cartStatus.setAttribute('aria-hidden', false);

          setTimeout(() => {
            cartStatus.setAttribute('aria-hidden', true);
          }, 1000);

          if (e.detail.originalTarget) {
            this.$nextTick(() => {
              if (!this.itemsRoot.contains(e.detail.originalTarget)) {
                let focusRoot;

                if (this.itemsRoot.closest('[role="dialog"]')) {
                  focusRoot =
                    this.itemsRoot.closest('[role="dialog"]').parentNode;
                } else {
                  focusRoot = this.itemsRoot;
                }

                this.$focus.within(focusRoot).first();
              }
            });
          }
        });
      },
      itemQuantityChange(key, value) {
        if (this.locked) return;

        const lineItemEl = this.$el.closest('li[data-cart-item-key]');
        const id = key ? key : lineItemEl.getAttribute('data-cart-item-key'),
          quantity = parseInt(!isNaN(value) ? value : this.$el.value, 10);

        const config = fetchConfigDefaults();

        let sections = this.sections;

        config.headers.Accept = 'application/javascript';

        config.body = JSON.stringify({
          id,
          quantity,
          sections,
          sections_url: window.location.pathname,
        });

        const lastValue = parseInt(this.$el.dataset.lastValue, 10);

        if (quantity !== lastValue) {
          lineItemEl.classList.add('opacity-50', 'cursor-progress');

          // UI optimista: actualiza el subtotal al instante. La respuesta del
          // servidor (morph) lo reconcilia después, así que si hubiera un
          // descuento a nivel de carrito que no escala lineal, se autocorrige.
          try {
            const unit = parseInt(
              lineItemEl.getAttribute('data-line-unit-price'),
              10
            );
            if (!isNaN(unit) && !isNaN(lastValue)) {
              const delta = (quantity - lastValue) * unit;
              document
                .querySelectorAll('[data-cart-subtotal]')
                .forEach((el) => {
                  const cents =
                    parseInt(el.getAttribute('data-subtotal-cents'), 10) + delta;
                  el.setAttribute('data-subtotal-cents', cents);
                  if (typeof window.formatMoney === 'function') {
                    el.textContent = window.formatMoney(
                      cents,
                      theme.defaultMoneyFormat
                    );
                  }
                });
            }
          } catch (e) {
            /* si algo falla, el morph del servidor pondrá el valor correcto */
          }

          const currentCount = Alpine.raw(Alpine.store('cart_count').count);

          this.locked = lineItemEl;

          fetch(theme.routes.cart_change_url, config)
            .then((res) => res.json())
            .then((data) => {
              if (data.status === 422) {
                const errorEl = lineItemEl.querySelector(
                  '[data-cart-quantity-error]'
                );

                errorEl.textContent = data.message;

                errorEl.classList.remove('hidden');

                lineItemEl.classList.remove('opacity-50', 'cursor-progress');

                this.$el.value = lastValue;
                this.$el.dispatchEvent(new Event('input'));
              } else {
                document.body.dispatchEvent(
                  new CustomEvent('switch:modalcart:cartqtychange', {
                    bubbles: true,
                    detail: { response: data, originalTarget: lineItemEl },
                  })
                );
              }
            })
            .catch(() => {
              document.getElementById('cart-errors').textContent =
                theme.strings.cartError;
            })
            .finally(() => {
              this.locked = null;
            });
        }
      },
      removeItem(key) {
        this.itemQuantityChange(key, 0);
      },
      // Cambio de talla/variante sin salir del carrito.
      // Shopify no permite "cambiar" la variante de una línea, así que primero
      // AÑADIMOS la nueva variante y, solo si tiene stock, quitamos la anterior.
      // De este modo, si la talla elegida está agotada, no se pierde el artículo.
      changeVariant(newId) {
        if (this.locked) return;

        const selectEl = this.$el;
        const newVariantId = parseInt(newId ? newId : selectEl.value, 10);
        const prevVariantId = selectEl.dataset.lastVariant;

        if (!newVariantId || String(newVariantId) === String(prevVariantId)) {
          return;
        }

        const lineItemEl = selectEl.closest('li[data-cart-item-key]');
        const oldKey = lineItemEl.getAttribute('data-cart-item-key');
        const qtyInput = lineItemEl.querySelector('input[type="number"]');
        const quantity = parseInt(qtyInput ? qtyInput.value : '1', 10) || 1;

        const revert = (message) => {
          if (prevVariantId) selectEl.value = prevVariantId;
          const errorEl = lineItemEl.querySelector('[data-cart-quantity-error]');
          if (errorEl && message) {
            errorEl.textContent = message;
            errorEl.classList.remove('hidden');
          }
          lineItemEl.classList.remove('opacity-50', 'cursor-progress');
          this.locked = null;
        };

        lineItemEl.classList.add('opacity-50', 'cursor-progress');
        this.locked = lineItemEl;

        const addConfig = fetchConfigDefaults();
        addConfig.headers.Accept = 'application/javascript';
        addConfig.body = JSON.stringify({
          id: newVariantId,
          quantity,
          sections: this.sections,
          sections_url: window.location.pathname,
        });

        fetch(theme.routes.cart_add_url, addConfig)
          .then((res) => res.json().then((data) => ({ ok: res.ok, data })))
          .then(({ ok, data }) => {
            // add.js devuelve status 422 (con description) si la talla está agotada
            if (!ok || data.status) {
              revert(data.description || data.message);
              return;
            }

            const removeConfig = fetchConfigDefaults();
            removeConfig.headers.Accept = 'application/javascript';
            removeConfig.body = JSON.stringify({
              id: oldKey,
              quantity: 0,
              sections: this.sections,
              sections_url: window.location.pathname,
            });

            return fetch(theme.routes.cart_change_url, removeConfig)
              .then((res) => res.json())
              .then((changeData) => {
                document.body.dispatchEvent(
                  new CustomEvent('switch:modalcart:cartqtychange', {
                    bubbles: true,
                    detail: {
                      response: changeData,
                      originalTarget: lineItemEl,
                    },
                  })
                );
                this.locked = null;
              });
          })
          .catch(() => {
            revert(theme.strings.cartError);
          });
      },
      _adjustQty(el, operation) {
        const inputEl = el
          .closest('li[key]')
          .querySelector('input[type="number"]');

        const lastValue = parseInt(inputEl.dataset.lastValue, 10);

        let newValue;

        if (operation == 'increment') {
          newValue = lastValue + 1;
        }

        if (operation == 'decrement') {
          if (lastValue > 1) {
            newValue = lastValue - 1;
          } else {
            newValue = 1;
          }
        }

        if (operation == 'remove') {
          newValue = 0;
        }

        inputEl.value = newValue;

        // this.$nextTick(() => {
        inputEl.dispatchEvent(new Event('change', { bubbles: true }));
        // });
      },
      increment() {
        this._adjustQty(this.$el, 'increment');
      },
      decrement() {
        this._adjustQty(this.$el, 'decrement');
      },
      remove() {
        this._adjustQty(this.$el, 'remove');
      },
    };
  });
});
